import { IUpdateUserStatusBulkActionPayload } from '../interfaces/update-user-status-bulk.action-payload.interface';

export class UpdateUserStatusBulk {
    static readonly type = '[User] UpdateUserStatusBulk';

    constructor(public payload: IUpdateUserStatusBulkActionPayload) {}
}
